/* External */
import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import { FormattedMessage } from 'react-intl';

/* Components */
import FocusableButton from '../FocusableButton';

/* Utils */
import { noOp } from '../../utils/functions';
import { gaService } from '../../services/gaService';
import { REPORT_GA } from '../../utils/constants';
import { Direction } from '../../utils/spatialNavigation';

/* Style */
import './WatchFromStartButton.scss';

function WatchFromStartButton({
  focusRestorable,
  onBecameFocused,
  hasFocusedChild,
  onPress,
}) {
  const handleEnterPress = useCallback(() => {
    onPress();
    gaService.sendEvent({
      action: REPORT_GA.GA_EVENT_ACTION_PDP_WATCH_FROM_START_CLICK,
      label: REPORT_GA.GA_EVENT_LABEL_PDP_WATCH_FROM_START_CLICK,
      category: REPORT_GA.GA_EVENT_CATEGORY_PDP,
    });
  }, [onPress]);

  const handleArrowPressButton = useCallback((direction) => direction !== Direction.UP, []);

  return (
    <FocusableButton
      className={`dtv-html5-c-watch-from-start-button ${
        hasFocusedChild ? 'dtv-html5-c-watch-from-start-button--focused' : ''
      }`}
      icon="refresh"
      focusRestorable={focusRestorable}
      onEnterPress={handleEnterPress}
      onBecameFocused={onBecameFocused}
      onArrowPress={handleArrowPressButton}
      primary
    >
      <FormattedMessage id="common.watchFromStart" />
    </FocusableButton>
  );
}

WatchFromStartButton.propTypes = {
  focusRestorable: PropTypes.bool,
  onBecameFocused: PropTypes.func,
  hasFocusedChild: PropTypes.bool.isRequired,
  onPress: PropTypes.func,
};

WatchFromStartButton.defaultProps = {
  onBecameFocused: noOp,
  focusRestorable: false,
  onPress: noOp,
};

export default memo(withFocusable(
  { trackChildren: true },
)(memo(WatchFromStartButton)));
